import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icons from '../../../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../../../components/Common/UI/Button';
import { getGuidanceSettingsFromStorage } from '../../../../../../../components/Pages/Home/SettingsModal/storage-utils';
import { StepProps } from '../../index';
import { Input } from '../../../../../../../components/Common/UI/Input';
import PdfViewer from '../../../../../../../components/Common/PdfViewer';

export default function PdfVerificationStep({ handleNextStep }: StepProps) {
  const { showCaptcha } = getGuidanceSettingsFromStorage();
  const [captchaInput, setCaptchaInput] = useState('');

  const handleNext = () => {
    handleNextStep();
    // if (captchaInput.length >= 6 || showCaptcha === false) {
    //   handleNextStep();
    // } else {
    //   notifyError('CAPTCHA should be 6 symbols', undefined, {
    //     background: '#fff',
    //   });
    // }
  };

  return (
    <>
      <div className="flex gap-4 items-center">
        <div>
          <Icons.AccountsFilled />
        </div>
        <div>
          <h2 className="text-lg font-bold">PDF Verification</h2>
          <p className="text-sm">
            Please verify you can see the sample eStatement and enter the code below to proceed.
          </p>
        </div>
      </div>

      <PdfViewer src="/financialInstitution/statements/captcha-pdf-verification.pdf" height="525px" />

      {showCaptcha === false ? (
        <p className="text-destructive">You disabled Sample Statement CAPTCHA in settings</p>
      ) : (
        <div className="bg-[#F5F7F9] py-4 flex flex-col gap-3 justify-center items-center font-semibold text-xl">
          <p>Please type the code you see in the PDF here:</p>
          <Input
            variant="white"
            className="w-[272px] tracking-widest"
            inputClassName="py-12 text-[36px] text-center border-[#EF9F0080]"
            placeholder="CAPTCHA"
            maxLength={6}
            value={captchaInput}
            onChange={e => setCaptchaInput(e.target.value)}
          />
          <p>
            If you are having difficulty reading the Security Code in the PDF, please{' '}
            <Link to="#" className="pointer-events-none text-[#EF9F00]">
              click here
            </Link>
          </p>
        </div>
      )}

      <div className="flex flex-wrap gap-4 justify-center sm:justify-between items-center">
        <Button className="bg-[#EF9F00] hover:bg-[#EF9F00E6]">I CANNOT see it</Button>
        <Button className="bg-[#51CF7C] hover:bg-[#51CF7CE6]" onClick={handleNext}>
          I CAN see PDF
        </Button>
      </div>
    </>
  );
}
